<section class="rounded-3xl bg-white px-6 py-6 shadow-tfr-sm sm:px-8">
  <div class="mb-4 flex flex-wrap items-end justify-between gap-2">
    <h2 class="text-[12px] font-semibold uppercase tracking-[0.16em] text-steel-gray">
      Valoraciones
    </h2>
    @if (reviewCount() > 0 && averageRating() !== null) {
      <p class="flex items-center gap-1.5 text-[13px] font-semibold text-midnight-indigo">
        <lucide-icon name="star" [size]="14" class="text-amber-500 fill-amber-500" />
        <span class="tabular-nums">{{ averageRating() | number:'1.1-1' }}</span>
        <span class="font-normal text-steel-gray">({{ reviewCount() }})</span>
      </p>
    }
  </div>

  @if (loading()) {
    <p class="text-[13px] text-steel-gray">Cargando valoraciones&hellip;</p>
  } @else if (reviews().length === 0) {
    <p class="text-[13px] text-steel-gray">A&uacute;n no hay valoraciones para este espacio.</p>
  } @else {
    <ul class="flex flex-col gap-4" role="list">
      @for (review of reviews(); track review.id ?? review.bookingId) {
        <li class="rounded-2xl border border-pale-gray bg-cloud-mist/40 p-4">
          <div class="flex flex-wrap items-center justify-between gap-2">
            <p class="text-[13px] font-semibold text-midnight-indigo">{{ guestLabel(review) }}</p>
            <div class="flex items-center gap-0.5" aria-label="{{ review.rating }} de 5 estrellas">
              @for (star of stars(review.rating); track star) {
                <lucide-icon
                  name="star"
                  [size]="14"
                  [class.text-amber-500]="star <= review.rating"
                  [class.fill-amber-500]="star <= review.rating"
                  [class.text-pale-gray]="star > review.rating" />
              }
            </div>
          </div>
          <p class="mt-2 text-[13px] leading-relaxed text-slate-blue whitespace-pre-line">{{ review.text }}</p>

          @if (review.ownerReply) {
            <div class="mt-3 rounded-xl border border-pale-gray bg-white px-3 py-2.5">
              <p class="text-[10px] font-semibold uppercase tracking-wider text-steel-gray">Respuesta del propietario</p>
              <p class="mt-1 text-[12px] leading-relaxed text-slate-blue whitespace-pre-line">{{ review.ownerReply }}</p>
            </div>
          } @else if (isOwner()) {
            <div class="mt-3">
              <label class="text-[10px] font-semibold uppercase tracking-wider text-steel-gray">Responder</label>
              <textarea
                rows="2"
                class="mt-1 w-full rounded-xl border border-pale-gray bg-white px-3 py-2 text-[13px] text-midnight-indigo"
                [value]="replyDraft(review.id ?? review.bookingId)"
                (input)="onReplyInput(review.id ?? review.bookingId, $event)"
                placeholder="Agradece o aclara detalles para futuros clientes"></textarea>
              <button
                type="button"
                class="mt-2 rounded-xl bg-midnight-indigo px-3 py-2 text-[12px] font-semibold text-snow-white disabled:opacity-40"
                [disabled]="replySavingId() === (review.id ?? review.bookingId) || !replyDraft(review.id ?? review.bookingId).trim()"
                (click)="submitReply(review)">
                @if (replySavingId() === (review.id ?? review.bookingId)) {
                  Guardando&hellip;
                } @else {
                  Publicar respuesta
                }
              </button>
            </div>
          }
        </li>
      }
    </ul>
    @if (replyError()) {
      <p class="mt-3 text-[12px] text-red-600">{{ replyError() }}</p>
    }
  }
</section>
